<script>
import makeSummary from '@/../plugit/shop-order/helpers/make-summary'
export default {
	props: ['order'],
	computed: {
		summary() {
			return makeSummary(this.order)
		},
		joinedItems() {
			return this.summary.getJoinedItems()
		},
	},
}
</script>

<template>
	<v-card v-if="order">
		<div class="pa-2 pa-sm-5">
			<template v-for="(jItem, i) of joinedItems">
				<OrderSummary-Item :order="order" :joined-item="jItem" :key="`i${i}`" />
				<v-divider v-if="i < joinedItems.length - 1" :key="`d${i}`" />
			</template>
			<OrderSummary-Totals :order="order" :summary="summary" class="pt-6" />
		</div>
	</v-card>
</template>

<style></style>
